import { create } from "zustand";
var useStore = create(function (set) { return ({
    draggedTask: null,
    setDraggedTask: function (taskId) { return set({ draggedTask: taskId }); },
}); });
export default useStore;
